/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, name: NonNullable<unknown> }} Artifact_Info_ByInputs */



/**
* | output |
* | --- |
* | "{date} by {name}" |
*
* @param {Artifact_Info_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_info_by = /** @type {((inputs: Artifact_Info_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Info_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.date} von ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.date} by ${i?.name}`)
});